import { render, staticRenderFns } from "./ModelPricingBepokePopUp.vue?vue&type=template&id=1be70ed8&scoped=true&"
import script from "./ModelPricingBepokePopUp.vue?vue&type=script&lang=js&"
export * from "./ModelPricingBepokePopUp.vue?vue&type=script&lang=js&"
import style0 from "./ModelPricingBepokePopUp.vue?vue&type=style&index=0&id=1be70ed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be70ed8",
  null
  
)

export default component.exports